import type {
  TemplateFilter,
  TemplateFilterCondition_TemplateFilterConditionCode as TemplateFilterConditionCode,
  PromptCategoryTemplateRatingRequest as PromptRating,
  AddCustomCategoryTemplateRequest_Scale as CustomTemplateScale,
  CustomCategoryTemplateCondition as CustomCategoryCondition,
  CustomCategoryTemplateRating as CustomCategoryRating,
  AiInsights_AiInsightListItem_EntityType as AiInsightUsage,
  AddPromptCategoryTemplateRequest as PromptTemplate,
  AiInsights_ValidatePromptTemplateResponse as ValidatePromptTemplateResponse,
  PromptAnomalies,
  AddPromptCategoryTemplateRequest_Scale as PromptScale,
} from '@zendesk/zqa-services/autoqa'
import { type OverlapWarning } from './categoryOverlapWarning'

export enum InsightType {
  SYSTEM = 'SYSTEM',
  CUSTOM = 'CUSTOM',
  PROMPT = 'PROMPT',
}

export interface InsightCustomTemplate {
  id?: string
  name?: string
  scale: CustomTemplateScale
  conditions: CustomCategoryCondition[]
  ratings: CustomCategoryRating[]
}

export interface InsightForm {
  id?: string
  name: string
  description: string
  insightType: InsightType
  insightUsage: AiInsightUsage
  customTemplate: InsightCustomTemplate
  promptTemplate: PromptTemplate
  promptAnomalies?: PromptAnomalies
  promptVersionId?: string
}

export enum InsightSpotlightType {
  CustomPhraseSearch = 'custom_phrase_search',
}

export interface InsightFormValidationError {
  title: string
  description?: string
  type: 'warning' | 'error'
}

export interface InsightFormErrors {
  name?: string
  description?: string
  filter?: string
  ratingFilters: Partial<
    Record<
      TemplateFilter['type'],
      Partial<Record<TemplateFilterConditionCode, Record<number, { error?: string; type?: string }>>>
    >
  >
  empty?: boolean
  conflict?: boolean
  prompt?: string[]
  promptLength?: boolean
  promptRating?: Record<number, string | null>
  validation?: InsightFormValidationError[]
  overlapWarnings?: OverlapWarning[]
}

export interface ValidatedInsightPrompt {
  prompt: string
  ratings: PromptRating[]
  canBeSpotlight: boolean
  canBeCategory: boolean
  validationHash: string
  isMetadataNeeded?: boolean
  metadata: Record<string, string>
  scale: PromptScale
}

export interface InsightCustomTemplateFilter extends TemplateFilter {
  labelString: string
}

export enum AutoValidationError {
  SECURITY = 'security',
  NON_LANGUAGE = 'non-language',
  OUT_OF_SCOPE = 'out of scope',
  OUTPUT_FORMATTING = 'output formatting',
  ANSWER_MATCHING = 'answer matching',
}

export enum ValidationAlertVariant {
  ERROR = 'error',
  INSIGHT_CHANGE = 'insight_change',
  USAGE_CHANGE = 'usage_change',
  SCALE_CHANGE = 'scale_change',
}

export interface AiSuggestion {
  prompt: string
  validation: ValidatePromptTemplateResponse
  reason: string
  similarityScore: number
}
